export { default as HowToRegIcon } from "@mui/icons-material/HowToReg";
